module.exports = __webpack_public_path__ + "static/media/flats.b704d3a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/flats.svg
// module id = 861
// module chunks = 0